import Button from "app/components/Button";
import Modal from "app/components/Modal";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { selectButtonLoading, selectSprintFormDta } from "../../redux/selector";
import { actions } from "../../redux/slice";
import LeftArea from "./LeftArea";
import RightArea from "./RightArea";

interface Props {
  onClose: () => void;
  
}
const Index: React.FC<Props> = ({ onClose }) => {
  const { project } = useParams();
  const dispatch = useDispatch();
  const loading = useSelector(selectButtonLoading);
  const form = useSelector(selectSprintFormDta);

  const handleClose = () => {
    onClose();
    dispatch(actions.clearSprintFormData());
  };
  const onSave = () => {
    dispatch(
      actions.createSprint({
        projectId: project as string,
        callback() {
          handleClose();
          dispatch(actions.fetchSprintList(project as string));
        },
      }),
    );
  };

  return (
    <Modal
      title="Add new sprint"
      onClose={() => handleClose()}
      submitText="Archive"
      modalClassName=" !w-[744px] "
      optionalFooterClass="bg-[#F4F5F7] rounded-b-md px-6 py-4"
      contentClassName=" flex items-center "
      renderModalFooter={
        <div className="flex justify-end gap-3">
          <Button
            className="!bg-[transparent]  border border-[secondary rounded !text-secondary h-[36px] text-sm font-medium w-[106px]"
            onClick={() => handleClose()}
          >
            Cancel
          </Button>
          <Button
            className="text-sm font-medium rounded bg-primary text-white h-[36px] w-[106px]"
            isLoading={loading}
            disabled={!form.name.name}
            onClick={() => {
              onSave();
            }}
          >
            Add
          </Button>
        </div>
      }
    >
      <div className=" flex gap-4 w-full ">
        <LeftArea />
        <RightArea />
      </div>
    </Modal>
  );
};

export default Index;
